import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { TranslateService } from '@ngx-translate/core';
import { IChoosenFilterInterface } from 'app/library/all-users/interfaces/choosen-filter.interface';
import { AllUsersApiService } from 'app/library/all-users/services/all-users.api-service';
import { MaxBrainAudience } from 'app/library/audience/models/audience.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { IEntityNode } from 'app/projects/shared/src/lib/interfaces/entity-node.interface';
import { takeUntil } from 'rxjs/operators';
import { GrowFilterByExperienceDialogComponent } from '../grow-filter-by-experience-dialog/grow-filter-by-experience-dialog.component';

@Component({
    selector: 'app-grow-filter-by-audience-dialog',
    templateUrl: './grow-filter-by-audience-dialog.component.html',
    styleUrls: ['./grow-filter-by-audience-dialog.component.scss'],
})
export class GrowFilterByAudienceDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    audiences: MaxBrainAudience[] = [];

    @Input()
    selectedAudiences: IChoosenFilterInterface[] = [];

    treeControl = new NestedTreeControl<IEntityNode>((node) => node.children);
    dataSource = new MatTreeNestedDataSource<IEntityNode>();
    displayedColumns = ['name', 'buttons'];

    searchValue: string;
    alreadySelectedAudiences: IChoosenFilterInterface[] = [];
    initialList: IChoosenFilterInterface[] = [];
    expandedNodes: string[] = [];
    filteredData: IEntityNode[] = [];
    originalData: IEntityNode[] = [];
    isUnassignedAudienceSelected: boolean;
    removable = true;
    isCommunityPage: boolean = false;

    constructor(public dialogRef: MatDialogRef<GrowFilterByExperienceDialogComponent>, private _translateService: TranslateService, private _allUsersService: AllUsersApiService) {
        super();
    }

    ngOnInit(): void {
        if (this.audiences.length && this.selectedAudiences.length) {
            const uniqueList = this.selectedAudiences.filter(
                (item) => !this.alreadySelectedAudiences.some((existing) => existing.entity.id === item.entity.id && existing.entity.type === item.entity.type)
            );
            // Set the mapped audience filters
            this._allUsersService.setGrowFiltersList('growAudienceFilter', [...this.alreadySelectedAudiences, ...uniqueList], true);
        }

        this._allUsersService.growFiltersList$.pipe(takeUntil(this._unsubscribeAll)).subscribe((filters) => {
            this.alreadySelectedAudiences = filters;
        });

        this.initialList = [...this.alreadySelectedAudiences];
    }

    clearFilters(): void {
        this.alreadySelectedAudiences = [];
        sessionStorage.setItem('growAudienceFilter', JSON.stringify(this.alreadySelectedAudiences));
        this.dialogRef.close(this.alreadySelectedAudiences);
    }

    removeFromList(entity: IChoosenFilterInterface, index: number): void {
        if (entity && index > -1) {
            this.alreadySelectedAudiences = this.alreadySelectedAudiences.filter((item) => item.entity.id !== entity.entity.id);
            this._allUsersService.setGrowFiltersList('growAudienceFilter', [...this.alreadySelectedAudiences.filter((item, idx) => idx !== index)], true);
        }
    }

    addToList(entities: IChoosenFilterInterface[]): void {
        this._allUsersService.setGrowFiltersList('growAudienceFilter', entities, true);
    }

    cancel(): void {
        this.alreadySelectedAudiences = this.initialList;

        this.dialogRef.close(false);
    }

    save(): void {
        this.dialogRef.close(this.alreadySelectedAudiences);
    }
}
